var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherMorePage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F5F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6673 12.0007C18.6673 15.6826 15.6826 18.6673 12.0007 18.6673C8.31875 18.6673 5.33398 15.6826 5.33398 12.0007C5.33398 8.31875 8.31875 5.33398 12.0007 5.33398C15.6826 5.33398 18.6673 8.31875 18.6673 12.0007ZM9.33394 11.3338C8.96575 11.3338 8.66728 11.6323 8.66728 12.0005C8.66728 12.3687 8.96575 12.6672 9.33394 12.6672H9.34061C9.7088 12.6672 10.0073 12.3687 10.0073 12.0005C10.0073 11.6323 9.7088 11.3338 9.34061 11.3338H9.33394ZM11.3339 12.0005C11.3339 11.6323 11.6324 11.3338 12.0006 11.3338H12.0073C12.3755 11.3338 12.6739 11.6323 12.6739 12.0005C12.6739 12.3687 12.3755 12.6672 12.0073 12.6672H12.0006C11.6324 12.6672 11.3339 12.3687 11.3339 12.0005ZM14.6673 11.3338C14.2991 11.3338 14.0006 11.6323 14.0006 12.0005C14.0006 12.3687 14.2991 12.6672 14.6673 12.6672H14.6739C15.0421 12.6672 15.3406 12.3687 15.3406 12.0005C15.3406 11.6323 15.0421 11.3338 14.6739 11.3338H14.6673Z",
    fill: "#111B48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherMorePage);
export default __webpack_public_path__ + "static/media/other-more-page.b2f35ae23e601f48cf72c7b5e1a6e170.svg";
export { ForwardRef as ReactComponent };